import React from 'react';
import { Paper, Typography } from '@mui/material';
import { NoteView } from '../../../../../../services/RefundService/types/refundTypes';

interface NoteContentSectionProps {
  note: NoteView;
}

export const NoteContentSection: React.FC<NoteContentSectionProps> = ({ note }) => (
  <Paper
    elevation={0}
    sx={{
      p: 3,
      backgroundColor: '#f8fafc',
      border: '1px solid #e2e8f0',
      borderRadius: 1.5,
      minHeight: '120px',
    }}
  >
    <Typography
      variant="body1"
      sx={{
        lineHeight: 1.6,
        color: '#1e293b',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
      }}
    >
      {note.text || 'No content available'}
    </Typography>
  </Paper>
);

export default NoteContentSection;
